module.exports = __webpack_public_path__ + "img/7.a21342c6.jpg";